import { View } from '@react-pdf/renderer'
import { ReactNode } from 'react'

import { ReportsType } from '@features/reports/enums/reportsType'

import { useReportsPdfDocument } from '../../../../contexts/reportsPdfDocumentContext'
import { columnPdfStyles } from '../../../../utils/columnPdfStyles'
import {
  ReportsPdfTableBalanceSheetHeader,
  ReportsPdfTableProfitAndLossHeader,
  ReportsPdfTableTrialBalanceHeader,
} from './elements/TableHeaders'

const HEADER_COMPONENTS: Record<ReportsType, () => ReactNode> = {
  [ReportsType.BalanceSheet]: ReportsPdfTableBalanceSheetHeader,
  [ReportsType.ProfitAndLoss]: ReportsPdfTableProfitAndLossHeader,
  [ReportsType.TrialBalance]: ReportsPdfTableTrialBalanceHeader,
}

export const ReportsPdfTableHeader = () => {
  const { reportType } = useReportsPdfDocument()

  const HeaderComponent = HEADER_COMPONENTS[reportType]

  return (
    <>
      <View style={columnPdfStyles.columnFixed}></View>
      <HeaderComponent />
    </>
  )
}
